export default "__VITE_PUBLIC_ASSET__dc6c6fad__"